import React from "react";
import PropTypes from "prop-types";
import "./Legend.scss";

const Legend = ({ colors, shouldAddConsumptionPrefix = true, legend }) => {
  const hasFourColors = colors.length === 4;

  return (
    <div className={`legend-container ${hasFourColors ? "four-colors" : ""}`}>
      <div className={`legend-colors`}>
        {colors.map((color, index) => (
          <div
            className={`color ${hasFourColors ? "four-colors" : ""}`}
            key={index}
          >
            <div className="step-color">{color.hexagon}</div>
            <div className="color-label">
              {shouldAddConsumptionPrefix &&
                !color?.shouldRemoveConsumptionPrefix &&
                "consumo "}{" "}
              <span>{color.label}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="legend-title">{legend ? legend : "Média móvel"}</div>
    </div>
  );
};

Legend.propTypes = {
  colors: PropTypes.array.isRequired
};

export default Legend;
